// extracted by mini-css-extract-plugin
var _1 = "DocFlowDateLinkCell-modulelink__Zuy2V EntityLink-moduleEntityLink__AOulJ";
export { _1 as "link" }
